import { fetchContentfulEntry } from 'connectors/contentful';
import { Entry } from 'contentful';

/**
 * Translates a single Contentful entry to the specified locale.
 * Falls back to the original entry if translation fails.
 */
export const translateContentfulEntry = async <T>(
  entry: Entry<T>,
  locale?: string
): Promise<Entry<T>> => {
  if (!locale) {
    return entry;
  }

  try {
    const translatedEntry = await fetchContentfulEntry<T>(entry.sys.id, locale);
    return translatedEntry;
  } catch (error) {
    return entry;
  }
};

/**
 * Translates multiple Contentful entries to the specified locale.
 * Falls back to original entries if individual translations fail.ß
 */
export const translateContentfulEntries = async <T>(
  entries: Entry<T>[],
  locale?: string
): Promise<Entry<T>[]> => {
  if (!locale || !entries.length) {
    return entries;
  }

  return Promise.all(
    entries.map((entry) => translateContentfulEntry(entry, locale))
  );
};

/**
 * Translates multiple Contentful entries and returns their fields.
 * Convenience method that combines translation with field extraction.
 */
export const translateContentfulEntryFields = async <T>(
  entries: Entry<T>[],
  locale?: string
): Promise<T[]> => {
  const translatedEntries = await translateContentfulEntries(entries, locale);
  return translatedEntries.map((entry) => entry.fields);
};
